import { render, staticRenderFns } from "./LoadingOrError.vue?vue&type=template&id=28b415dc&lang=pug&"
import script from "./LoadingOrError.vue?vue&type=script&lang=js&"
export * from "./LoadingOrError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports